import React from 'react'
import { ReactComponent as Icon } from 'assets/menuWide/jackpot.svg'

export default function JackpotIcon(props: any) {
  return (
    <Icon {...props} />
  )
}